import { render, staticRenderFns } from "./WorldCongressLoPresidentRegistrationCreate.vue?vue&type=template&id=0590272e"
import script from "./WorldCongressLoPresidentRegistrationCreate.vue?vue&type=script&lang=js"
export * from "./WorldCongressLoPresidentRegistrationCreate.vue?vue&type=script&lang=js"
import style0 from "./WorldCongressLoPresidentRegistrationCreate.vue?vue&type=style&index=0&id=0590272e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports